export const EPrimarySubmissionMethod = {
  Batch: "Batch",
  Bulk: "Bulk",
  Email: "Email",
  ULP: "ULP",
  FTP: "FTP",
  Portal: "Portal",
  SFTP: "SFTP",
  // MDO_Printer: "MDO Printer",
  Virtual_Printer: "Virtual Printer",
  Portal_Bulk: "Portal_Bulk",
  BOT: "BOT",
};

export const EReportType = {
  System: "System",
  Bulk: "Bulk",
  Batch: "Batch",
};
